import object from "lodash/object";
import { toastr } from "react-redux-toastr";
import { fetchRequest } from "../../utils/http.ts";
import { getAccessToken } from "../../utils/tokens";
import {
  getBillingServieUrl as billingSerivceUrl,
  getHttpProtocol as scheme,
} from "../../utils/requests";
import { logError } from "../../components/Errors";

export const BILLING_ERROR = "BILLING_ERROR";
export const SET_BILLING = "SET_BILLING";
export const FETCH_BILLING = "FETCH_BILLING";

export function setBillingError(err) {
  return {
    type: BILLING_ERROR,
    error: err,
  };
}

export function setBillingMethods(payload) {
  return {
    type: SET_BILLING,
    payload,
  };
}

export function fetchBillingMethods(userId) {
  return async function billingMethods(dispatch, getState) {
    const token = getAccessToken();
    let response = null;

    const state = getState();

    const { data: client } = state.client;

    const fetchBillingUrl = `${scheme}//${billingSerivceUrl}/billing?user_uuid=${userId}`;
    try {
      response = await fetchRequest({
        path: fetchBillingUrl,
        options: {
          token,
          headers: { "Content-Type": "application/json" },
        },
      });

      if (response && response.ok) {
        const body = await response.json();

        const { data } = body;

        const cards = data.filter((method) => method.isVerified === true);

        return dispatch(setBillingMethods(cards));
      }

      throw new Error(
        `Request returned with invalid status: ${response.status}`,
      );
    } catch (err) {
      logError({
        feature: FETCH_BILLING,
        message: err.message,
        request: {
          method: "GET",
          path: fetchBillingUrl,
        },
        client: object.get(client, "uuid"),
      });
      toastr.warning("Error", "An error occured. Please try again later.");
      return dispatch(setBillingError(err));
    }
  };
}
